<template lang="pug">
.backtotop
    router-link.link(to="/")
        img(src="@/assets/img/backtotop.svg")
</template>
<style lang="scss" scoped>
.backtotop {
    width: 100%;
    margin: 36px 0 24px 0;
    @media #{$pc} {
        margin: 64px 0;
    }

    > .link {
        display: block;
        width: 120px;
        margin: 0 auto;
    }
}
</style>
<script>
export default {};
</script>
